import { Component, Input, OnInit } from '@angular/core';
import { ComponentLists } from 'src/app/core/models/common-models';
import { SpecRequestDto } from 'src/app/core/models/spec-models';
import { SpecBackendService } from '../../core/services/spec-backend.service';
import { MultiSpecFormValue } from '../models/multi-spec.model';
import { MultiSpecService } from '../services/multi-spec.service';

@Component({
  selector: 'app-create-multi-spec',
  templateUrl: './create-multi-spec.component.html',
  providers: [MultiSpecService]
})
export class CreateMultiSpecComponent implements OnInit {
  @Input() categoryId: number = 0; 
  @Input() screenTitle: string = 'Spec';

  componentLists: ComponentLists = {} as ComponentLists;

  constructor(
    private specService: SpecBackendService,
    public multiService: MultiSpecService
  ) { }

  ngOnInit(): void {
    this.specService.getComponetListByCategoryId(this.categoryId)
      .subscribe(lists => {
        this.componentLists = lists;
        this.multiService.setFinisingOptions(this.componentLists.finishing);
      });
  }

  submitForm(): void {
    const request = new SpecRequestDto(this.multiService.headerForm.value);

    if(request.categoryId === 0) {
      request.categoryId = this.categoryId;
    }

    request.setMultiSpecDetails(<MultiSpecFormValue>this.multiService.detailForm.value);
    this.specService.createSpec(request);
  }

}
